var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    clipPath: "url(#clip0_9747_114077)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM2.4 10C2.4 14.1974 5.80264 17.6 10 17.6C14.1974 17.6 17.6 14.1974 17.6 10C17.6 5.80264 14.1974 2.4 10 2.4C5.80264 2.4 2.4 5.80264 2.4 10Z",
    fill: "#6851FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.2C10 0.537258 10.5392 -0.00742511 11.1971 0.0719144C12.0991 0.18068 12.984 0.412094 13.8268 0.761205C15.0401 1.26375 16.1425 2.00035 17.0711 2.92893C17.9997 3.85752 18.7362 4.95991 19.2388 6.17317C19.5879 7.016 19.8193 7.90086 19.9281 8.80287C20.0074 9.46084 19.4627 10 18.8 10C18.1373 10 17.6097 9.45947 17.5055 8.80497C17.412 8.21822 17.2499 7.64307 17.0215 7.09161C16.6395 6.16953 16.0797 5.33171 15.374 4.62599C14.6683 3.92026 13.8305 3.36045 12.9084 2.97852C12.3569 2.75009 11.7818 2.58797 11.195 2.49454C10.5405 2.39033 10 1.86274 10 1.2Z",
    fill: "#6851FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9747_114077"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.68969fb36e3f1c4bd1e687fd54846006.svg";
export { ForwardRef as ReactComponent };